module.exports = __webpack_public_path__ + "static/media/youstyLogoLong.08b0b596.png";